<div class="container-fluid animated fadeIn">
	<div class="row flex-column align-items-center my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title text-center">
				{{ 'supplier-upload.pageTitle' | translate }}
			</div>
		</div>

		<!-- CARD -->
		<div class="col-12 col-xl-8">
			<eif-custom-stepper
				[steps]="steps"
				[currentStep]="currentStep">
			</eif-custom-stepper>

			<div class="simple-card is-card-header top-line">
				<div>
					<p class="section-label">
						{{ 'supplier-upload-step1.companyContextualizationText' | translate }}
					</p>
					@if (companies?.length > 1) {
						<div class="section-wrapper is-secondary-section">
							<eif-custom-select
								[label]="'supplier-upload-step1.company' | translate"
								[options]="companyOptions"
								[placeholder]="'supplier-upload-step1.company' | translate"
								[concatOptions]="true"
								[value]="associatedCompanyId"
								(selectionChange)="onCompanySelectionChange($event)"
								[fullWidth]="true"
								[required]="true">
							</eif-custom-select>
						</div>
					}
					@if (companies?.length === 1) {
						<div class="section-wrapper is-secondary-section">
							<eif-company-card-minimal
								[company]="companies[0]"
								[showCompanyImage]="false"></eif-company-card-minimal>
						</div>
					}
				</div>
			</div>

			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex flex-grow-1">
					<a
						role="button"
						class="is-color-primary"
						(click)="openInstructionsModal()">
						<i class="fa-solid fa-info-circle me-2"></i>
						<span>{{ 'supplier-upload.howToUpload' | translate }}</span>
					</a>
				</div>
				<div class="d-flex align-items-center justify-content-xs-center justify-content-end gap-3 mt-4">
					<eif-custom-button
						[text]="'button.cancel' | translate"
						[color]="'neutral'"
						(action)="redirectToCompanies()">
					</eif-custom-button>
					@if (hasEnteredRequiredData()) {
						<eif-custom-button
							[text]="'supplier-upload-step1.goToNextStep' | translate"
							[disabled]="isPerformingRequest"
							(action)="redirectToUploadSuppliersStep2()">
						</eif-custom-button>
					}
				</div>
			</div>
		</div>
	</div>
</div>
